export default {
  'StripeSecurePayments.securePayment': {
    en: 'Secure paymnents',
    fr: 'Paiements sécurisés',
  },
};
